exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pattern-gallery[data-v-1d68c87e]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:-7px -10px}.pattern-gallery>[data-v-1d68c87e]{margin:7px 10px}.link[data-v-1d68c87e]{display:block;color:inherit;text-decoration:inherit}.preview[data-v-1d68c87e]{position:relative;display:block;width:300px;height:200px;background:#f7f7f7}.caption-container[data-v-1d68c87e]{position:absolute;top:0;left:0;display:-ms-flexbox;display:flex;width:100%;height:100%;-ms-flex-align:center;align-items:center}.caption[data-v-1d68c87e]{width:100%;text-align:center;font-size:20px;color:#fff;visibility:hidden}.link:focus .preview[data-v-1d68c87e],.link:hover .preview[data-v-1d68c87e]{background:#45758f}.link:focus .caption[data-v-1d68c87e],.link:hover .caption[data-v-1d68c87e]{visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d68c87e","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/client/components/PatternGallery.vue
// module id = 528
// module chunks = 1